import React, { FC, useEffect } from 'react';
import DatePicker from "react-datepicker";
import { addDays } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { resetDeliveryOptions, setPlayRange } from '../../stateReducers/deliverySlice';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { getDaysArray, isInPromoInterval, promoPlayRange } from '../../api/PromotionService';

interface PlayRangePickerInterface {
    minDate: Date,
}

const PlayRangePicker: FC<PlayRangePickerInterface> = ({
            minDate,
        }) => {
    const {t} = useTranslation();
    const formType = useAppSelector((state) => { return state.delivery.formType; });
    const maxStepReached = useAppSelector((state) => { return state.globals.maxStepReached; });
    const activePromo = useAppSelector((state) => { return state.delivery.activePromo; });
    const lang = useAppSelector((state) => { return state.globals.lang; });

    /**
     * Normally 1 day. In the case of YouthPromo, they get to play for 3 days.
     */
    const range = (playStart: Date) => {
        if (isInPromoInterval(playStart, lang, formType) && activePromo !== null) {
            return promoPlayRange(playStart, lang, formType);
        } else {
            return 1;
        }
    };

    const d = useAppDispatch();
    function changePlayDates(playStart: Date) {
        d(resetDeliveryOptions(null));
        d(setPlayRange(
            {
                playStart: playStart,
                range: range(playStart)
            }
        ));
    }
    const playStart = useAppSelector((state) => { return state.delivery.playStart; });
    const playEnd = useAppSelector((state) => { return state.delivery.playEnd; });

    useEffect(() => {
        if (maxStepReached === 2) {
            changePlayDates(minDate);
        }
    }, []);

    useEffect(() => {
        if (playStart) {
            changePlayDates(playStart);
        }
    }, [activePromo]);

    return (
        <div>
            <DatePicker
                className="form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-orange-200 focus:shadow-none focus:outline-none focus:outline-none"
                popperClassName='play-range-picker-popper-2' // -2 signals that two months are shown
                onChange={(date: Date | null) => {
                    if (date) {
                        changePlayDates(date);
                    }
                }}
                selected={playStart}
                placeholderText={t('delivery.selectDeliveryDatePlaceholder')}
                minDate={minDate}
                calendarStartDay={1}
                open
                // portalId="calendar"
                dateFormat="dd-MM-yyyy"
                highlightDates={getDaysArray(playStart!, playEnd!)}
                monthsShown={2}
                popperPlacement="bottom-start"
                popperModifiers={[
                    {
                      name: "flip",
                      options: {
                        fallbackPlacements: ["bottom-start"],
                        allowedAutoPlacements: ["bottom-start"],
                      },
                    },
                  ]}
            />
            <div id='range-calendar'></div>
        </div>
    );
}

export default PlayRangePicker;
